// extracted by mini-css-extract-plugin
export default {"unknownPage":"unknown_page_unknownPage__qv8an","title":"unknown_page_title__V2ke6","description":"unknown_page_description__rFGZw"};